<div
	*ngIf="
		showPage === true &&
		isLoggedIn === true &&
		isOnlinePayments === false &&
		isClientPortal === false &&
		isCustomerForms === false &&
		isSurvey === false &&
		isNewAccountSetup === false &&
		isQuickbooksOAuthResponse === false &&
		isCleanClaimsAuthResponse === false &&
		isGoogleCalendarAuthResponse === false &&
		isOutlookCalendarAuthResponse === false
	"
	class="main-container">
	<div class="content">
		<side-menu *ngIf="!isiFrame"></side-menu>
		<div id="main-area-container" class="main-area-container">
			<header-bar *ngIf="!isiFrame"></header-bar>
			<div class="main-area">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
	<div *ngIf="!isiFrame" class="main-footer">
		<footer-bar></footer-bar>
	</div>

	<!-- Reference material for the pages around it, so it rides the shell rather than being
	     somewhere you have to navigate to. Renders nothing unless the account is onboarding. -->
	<onboarding-dock *ngIf="!isiFrame"></onboarding-dock>
	<!-- Lives out here rather than in a route so the docked panel survives page changes -->
	<team-chat-widget *ngIf="showTeamChat"></team-chat-widget>
	<!-- Company 3 only: quick theme picker for checking every page against every theme -->
	<theme-switcher *ngIf="showThemeSwitcher"></theme-switcher>
</div>

<div
	*ngIf="
		showPage === true &&
		isOnlinePayments === false &&
		isClientPortal === false &&
		(isLoggedIn === false ||
			isCustomerForms === true ||
			isSurvey === true ||
			isNewAccountSetup === true ||
			isQuickbooksOAuthResponse === true ||
			isCleanClaimsAuthResponse === true ||
			isGoogleCalendarAuthResponse === true ||
			isOutlookCalendarAuthResponse === true)
	">
	<router-outlet></router-outlet>
</div>

<!-- The three outlets above and here must be mutually exclusive.  Two of them showing at once - which is
     what happens if a flag is only ever ADDED to one branch and not EXCLUDED from the others - renders the
     routed component twice: an outlet created after the route has already resolved activates itself on
     init, so a lazy chunk that beats the showPage flip put the whole client portal on the page twice. -->
<div *ngIf="showPage === true && (isOnlinePayments || isClientPortal)">
	<router-outlet></router-outlet>
</div>

<http-error-dialog></http-error-dialog>
<custom-error-dialog></custom-error-dialog>
<version-release-dialog #dialogRef [isOpen]="showDialog" [isMobile]="false" (onClose)="onVersionDialogClose()" [versionModels]="versionModels"></version-release-dialog>
<announcement-dialog [isOpen]="showAnnouncementDialog" [isMobile]="false" [announcement]="announcement" (onClose)="onAnnouncementDialogClose()"></announcement-dialog>
<feature-popup [featurePopup]="featurePopup"></feature-popup>

<div style="position: absolute; left: 50%; top: 20%">
	<ngx-confetti-explosion *ngIf="showConfetti" (explosionDone)="showConfetti = false"></ngx-confetti-explosion>
</div>
